import React from "react"
import Slider from "./Slider"
import PostSaleProduct from "./PostSaleProduct";
import PostSaleProductPlaceholder from "./PostSaleProductPlaceholder";
import SaleProductCard from "../../shared/SaleProductCard";
import SliderComponent from "./SliderComponent";


const uuid = require('uuid/v1')

const SaleSlider = ({ sales, backgroundColor, textColor, borderColor, numOfProducts }) => {
  const colors = { backgroundColor, textColor, borderColor}
  
  const placeholderProducts = []
  for( var i=0; i < numOfProducts - sales.length; i++){  
    placeholderProducts.push(<PostSaleProductPlaceholder colors = {colors} key={i}/>)
  }
  return (
   <SliderComponent direction={'center'} sliderId={uuid()} >
      { sales.slice(0, numOfProducts).map(sale => {
          return (
            <SaleProductCard
              sale={sale}
              colors={colors}
              key={sale.id}
            />
          );
        })
      }
      {
        placeholderProducts
      }
    </SliderComponent>
  )
}

export default SaleSlider
